module.exports = __webpack_public_path__ + "assets/img/202108-2W.65617be8.png";